'use strict';
import angular from 'angular';
import advancedDemographicsHtmlUrl from './views/advancedDemorgraphicsList.html';
import snapChildDataHtmlUrl from './views/snapRecursiveTemplate.html';

var app = angular.module('app.advancedDemographics.component', []);

app.component('advancedDemographics', {
    bindings: {
        showActions: '=',
        selectedAdvancedDemographics: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: advancedDemographicsHtmlUrl,

    // The controller that handles our component logic
    controller: function (ProductService) {
        var self = this;

        self.inMarketSearch = "";
        self.reMarketSearch = "";
        self.demographicsList = [];
        self.snapChildDataHtmlUrl = snapChildDataHtmlUrl;

        self.IsChildObjectVisible = function (parent, child) {
            var searchKey = $scope.search;
            var returnVal = true;
            if (undefined != searchKey && null != searchKey && searchKey.length > 0) {
                returnVal = ((child.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) ||
                    (parent.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1));
            }
            return returnVal;
        }

        self.handleSelectSubChild = function (item, child, selectedAdvancedDemographics, indx, type) {
            if (type == "Demographics") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    var selIndex = selectedAdvancedDemographics.demographics.indexOf(child);
                    var selIndex = _.findIndex(selectedAdvancedDemographics.demographics, {id: child.id});
                    if (selIndex >= 0) {
                        selectedAdvancedDemographics.demographics.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedAdvancedDemographics.demographics.push(child);
                }
            } else {
                child.status = 'selected';
                child.isChecked = true;
                selectedAdvancedDemographics.demographics.push(child);
            }
        }

        self.removeAdvancedDemographicsSet = function (data, index) {
            if (self.selectedAdvancedDemographics.length == index + 1) {
                self.selectedAdvancedDemographics.splice(index, 1);
                var selIndex = index - 1;
                if (selIndex >= 0) {
                    self.selectedAdvancedDemographics[selIndex].excludeEnabled = true;
                    self.selectedAdvancedDemographics[selIndex].overLapEnabled = true;
                    if (data.excludeAdded) {
                        self.hideExclude = false;
                    }
                }
            } else {
                self.selectedAdvancedDemographics.splice(index, 1);
                if (data.excludeAdded) {
                    self.hideExclude = false;
                    var indexVal = self.selectedAdvancedDemographics.length - 1;
                    self.selectedAdvancedDemographics[indexVal].excludeEnabled = true;
                }
            }
        }

        self.removeDemographics = function (item, selectedAdvancedDemographics, demographicsList) {
            var selIndex = selectedAdvancedDemographics.indexOf(item);
            if (selIndex >= 0) {
                selectedAdvancedDemographics.splice(selIndex, 1);
            }
            self.clearSelectedData(item, demographicsList);
        }


        self.handleSelectDemographics = function (demographic, selectedAdvancedDemographics) {
            if (!demographic.isChecked) {
                demographic.status = '';
                demographic.isChecked = false;
                var selIndex = selectedAdvancedDemographics.demographics.indexOf(demographic);
                if (selIndex >= 0) {
                    selectedAdvancedDemographics.demographics.splice(selIndex, 1);
                } else {
                    if (selectedAdvancedDemographics.demographics && selectedAdvancedDemographics.demographics.length > 0) {
                        if (_.find(selectedAdvancedDemographics.demographics, {id: demographic.id})) {
                            var index = _.findIndex(selectedAdvancedDemographics.demographics, {id: demographic.id});
                            selectedAdvancedDemographics.demographics.splice(index, 1);
                        }
                    }
                }
            } else {
                demographic.status = 'selected';
                demographic.isChecked = true;
                selectedAdvancedDemographics.demographics.push(demographic);
            }
        }

        self.clearSelectedData = function (item, totalList) {
            _.each(totalList, function (e) {
                if (e.id == item.id) {
                    e.status = '';
                    e.isChecked = false;
                }
                if (e.childData && e.childData.length > 0) {
                    self.clearSelectedData(item, e.childData)
                }
            })
        }

        self.removeAdvancedDemographics = function (item, selectedDemographics, demographicsList) {
            var selIndex = selectedDemographics.indexOf(item);
            if (selIndex >= 0) {
                selectedDemographics.splice(selIndex, 1);
            }
            self.clearSelectedData(item, demographicsList);
        }


        self.getAdvancedDemographics = function () {
            ProductService.getAdvancedDemographicsContents({
                clientId: self.clientId,
                clusterId: self.clusterId
            }).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var demographics = {};
                        demographics.id = content.id;
                        demographics.name = content.name.charAt(0).toUpperCase() + content.name.replace("_", " ").slice(1);
                        demographics.status = "";
                        demographics.isChecked = false;
                        demographics.isExpand = false;
                        demographics.parentName = content.parentName;
                        demographics.childData = content.childData;
                        demographics.type = content.type;
                        self.demographicsList.push(content);
                    });
                    _.each(self.selectedAdvancedDemographics, function (item) {
                        item.demographicsList = angular.copy(self.demographicsList);
                    })
                    processDemographicsData();
                }
            }, function (error) {
            });
        }


        var processDemographicsData = function () {
            _.each(self.selectedAdvancedDemographics, function (data) {
                _.each(data.advancedDemographics, function (item) {
                    _.each(data.advancedDemographicsList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubAdvancedDemographics(e.childData, data.demographics);
                        }
                    })
                })
            })
        }


        var processSubAdvancedDemographics = function (childData, selectedAdvancedDemographics) {
            _.each(selectedAdvancedDemographics, function (item) {
                _.each(childData, function (e) {
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubAdvancedDemographics(e.childData, selectedAdvancedDemographics);
                    }
                })
            })
        }


        self.setExclude = function () {
            _.each(self.selectedAdvancedDemographics, function (item) {
                if (item.excludeAdded) {
                    self.hideExclude = true;
                }
            })
        }

        self.initComponent = function () {
            if (self.selectedAdvancedDemographics && !_.isEmpty(self.selectedAdvancedDemographics)) {
                self.selectedAdvancedDemographics = JSON.parse(self.selectedAdvancedDemographics);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getAdvancedDemographics();
                    self.setExclude();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedAdvancedDemographics = [{
                    demographics: [],
                    overLapEnabled: true,
                    excludeEnabled: true
                }];
                self.enableViewMode = false;
                self.getAdvancedDemographics();
            }
        };

        self.initComponent();
    }

});
